import Model from '@/models/Model.js';

export default class GradingScheme extends Model {
    static entity = 'grading_schemes';

    static modelName = 'GradingScheme';

    static fields() {
        return {
            id: this.attr(null),
            grading_scheme_template_id: this.attr(null),
            title: this.attr(null),
            description: this.attr(null),

            ...super.fields(),

            grading_scheme_criterias: this.hasMany('grading_scheme_criterias', 'grading_scheme_criterias_id'),
            course: this.hasOne('courses', 'course_id'),
            course_grades: this.hasMany('course_grades', 'course_grades_id'),
        };
    }
}
